import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import MainWrapper from "../layouts/MainWrapper";
import CardWrapper from "../layouts/CardWrapper";
import DataTable from "../components/Table/Table";
import Image from "react-bootstrap/Image";
import PageTitle from "../components/PageTitle";
import StatusBadgeClientInvite from "../components/StatusBadge/StatusBadgeClientInvite";
import ClientAccessDetailsPanel from "../components/DetailsPanel/ClientAccessDetailsPanel";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import AlertCustom from "../components/AlertCustom/AlertCustom";
import { useAlert } from "../contexts/AlertContext";
import { updateInviteeStatus } from "../services/inviteService";
import {
  Formik,
  Form as FormikForm,
  Field,
  FieldArray,
  ErrorMessage,
} from "formik";
import * as Yup from "yup";
import TablePagination from "../components/TablePagination/TablePagination";
import CustomBreadcrumb from "../components/CustomBreadcrumb";
import { useAtom } from "jotai";
import { authAtom } from "../states/auth";
import { inviteeList, inviteUsers } from "../services/inviteService";
import { fi } from "react-day-picker/locale";
import ProgressBar from "react-bootstrap/ProgressBar";
import ImagePreviewLightbox from "../components/ImagePreviewLightbox";
import useDebounce from "../utils/useDebounce";
import { Link, useNavigate } from "react-router-dom";
import { PlusIcon } from "../components/SVGIcon";

const ClientAccess = () => {
  const [auth] = useAtom(authAtom);
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [searchFlag, setSearchFlag] = useState(false);
  const [statusFilter, setStatusFilter] = useState(["1", "2", "3"]);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [progress, setProgress] = useState(0);
  const [filter, setFilter] = useState({
    no_of_result: 10,
    page: 1,
    search: "",
    statusFilters: [],
    sorting: [],
  });
  const debouncedSearchTerm = useDebounce(filter, searchFlag ? 500 : 0);
  const [inviteeListData, setInviteeListData] = useState(null);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { showAlert } = useAlert();
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const fetchInvitees = async () => {
    try {
      const data = await inviteeList(filter);
      setInviteeListData(data?.data);
      setTotalResults(data?.totalResult);
    } catch (error) {
      console.error("Error fetching invitees:", error);
      showAlert({
        title: "Contact Access Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  const updateInviteeListData = (inviteeData) => {
    const row = inviteeListData.findIndex((e) => e.id == inviteeData.id);

    inviteeListData[row] = inviteeData;
    setInviteeListData([...inviteeListData]);
    // setSelectedItem({ ...inviteeData });
  };

  const rowHandler = (row) => {
    setSelectedItem(row);
    document.body.classList.add("sidebar-collapsed");
  };

  const updateInviteeStatusHandle = async (item) => {
    setNotification(null);
    try {
      const res = await updateInviteeStatus({ status: !item.status }, item.id);
      console.log("Update Invite successful:", res);
      updateInviteeListData({ ...item, status: !item.status });

      // await fetchInvitees();
      showAlert({
        title: "Contact Notification",
        message: res?.message ?? "something went wrong",
        variant: "success",
      });
      return true;
    } catch (error) {
      showAlert({
        title: "Contact Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
      return false;
      // console.error("Update Invite failed:", error.response.data.message);
    } finally {
      setShowModal(false);
    }
  };

  const handleShowProgressBar = () => {
    setProgress(0); // reset
    let start = 0;
    const interval = setInterval(() => {
      start += 2;
      if (start >= 100) {
        start = 0;
        setProgress(0);
        clearInterval(interval);
      }
      setProgress(start);
    }, 100); // 100 * 50 = 5000ms = 5 seconds
  };

  /*  Status filter event handling */
  const handleStatusFilterChange = (e, statusCode) => {
    let tempStatus = [...statusFilter];
    const checked = e.target.checked;

    if (checked) {
      tempStatus.push(statusCode);
    } else {
      tempStatus = tempStatus.filter((item) => item !== statusCode);
    }

    setStatusFilter(tempStatus);
  };

  const handleStatusFilterApply = () => {
    setShowStatusDropdown(false);
    setFilter((prev) => ({
      ...prev,
      statusFilters: statusFilter,
    }));
  };
  /*  Status filter event handling */

  const changeFilterCriteria = (e) => {
    if (e.target.name == "search") {
      filter.page = 1;
      setSelectedPage(1);
      setSearchFlag(true);
    }
    console.log(e.target.name, e.target.value);
    filter[e.target.name] = e.target.value;
    setFilter({ ...filter });
    console.log("filter", filter);
  };

  const changeFilterCriteriaByName = (name, value) => {
    console.log(name, value);
    filter[name] = value;
    setFilter({ ...filter });
    console.log("filter", filter);
  };

  useEffect(() => {
    changeFilterCriteriaByName("page", selectedPage);
  }, [selectedPage]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      console.log('Performing search for:', debouncedSearchTerm);
      // In a real application, you would make an API call here
      fetchInvitees();
      setSearchFlag(false);
    } else {
      console.log('Search term cleared.');
    }
  }, [debouncedSearchTerm]);

  const [selectedItem, setSelectedItem] = useState(null);
  const columns = [
    { label: "Name", key: "invited_user.firstName" },
    { label: "Email", key: "email" },
    {
      label: "Invitation Status",
      key: "status",
      // render: (value) => <StatusBadgeClientInvite status={value} />,
    },
  ];
  const navigate = useNavigate();
  const BeadcrumbItems = [{ label: "Contacts", active: true }];
  return (
    <>
      <Row className="align-items-end justify-content-between mb-4">
        <Col lg="7">
          <CustomBreadcrumb items={BeadcrumbItems} />
          <PageTitle title="Contacts" />
        </Col>
        <Col lg="5" className="text-end">
          <Dropdown>
            <Dropdown.Toggle
              variant="primary"
              className="btn btn-md d-inline-flex align-items-center gap-2"
              id="client-invite"
              as={Button}
            >
              <PlusIcon /> Invite Contact
            </Dropdown.Toggle>

            <Dropdown.Menu className="template-dropdown-menu dropdown-menu-end">
              <Row className="gx-2">
                <Col md="6">
                  <div
                    className="template-dropdown-item bg-blue-100"
                    onClick={handleShow}
                  >
                    <div className="template-dropdown-icon rounded-pill bg-white text-blue-600">
                      <PlusIcon />
                    </div>
                    <p className="fs-14 fw-500 text-gray-700 mt-2 mb-0">
                      Invite <br /> Contacts
                    </p>
                  </div>
                </Col>
                <Col md="6">
                  <div
                    className="template-dropdown-item bg-green-100"
                    onClick={() => navigate("/client-register")}
                  >
                    <div className="template-dropdown-icon rounded-pill bg-white text-green-600">
                      <PlusIcon />
                    </div>
                    <p className="fs-14 fw-500 text-gray-700 mt-2 mb-0">
                      Register <br /> Contact
                    </p>
                  </div>
                </Col>
              </Row>
            </Dropdown.Menu>
          </Dropdown>

        </Col>
      </Row>
      <MainWrapper>
        <CardWrapper>
          <Row className="align-items-center gy-4 gy-xxl-0 mb-4">
            <Col xxl="9">
              <h2 className="fs-5 fw-semibold text-gray-800 mb-0">
                All  Contacts
              </h2>
            </Col>
            <Col xxl="3" xl="8" className="text-end">
              <input
                onChange={changeFilterCriteria}
                type="text"
                name="search"
                className="form-control form-control-search"
                aria-label="Search Input"
                placeholder="Search here.."
                autoComplete="off"
              />
            </Col>
          </Row>
          <DataTable>
            <thead>
              <tr>
                {columns.map((col, index) => {
                  const sortingKey =
                    col.key.split(".").length > 1
                      ? col.key.split(".")[1]
                      : col.key.split(".");
                  return (
                    <th key={index} className="cursor-pointer">
                      <div className="d-flex align-items-center gap-1">
                        {col.label}
                        <div>
                          {col.label === "Invitation Status" && (
                            <Dropdown
                              show={showStatusDropdown}
                              onToggle={(isOpen) =>
                                setShowStatusDropdown(isOpen)
                              }
                            >
                              <Dropdown.Toggle
                                variant="light"
                                className="btn-reset dropdown-toggle-none"
                                align="end"
                              >
                                <Image
                                  src="/images/funnel.svg"
                                  width={20}
                                  height={20}
                                  alt="Funnel Icon"
                                />
                              </Dropdown.Toggle>

                              <Dropdown.Menu
                                className="filter-dropdown-menu dropdown-menu-end p-0"
                                align="end"
                                popperConfig={{
                                  modifiers: [
                                    {
                                      name: "offset",
                                      options: { offset: [0, 5] },
                                    },
                                  ],
                                }}
                              >
                                <div className="px-3 py-2 border-bottom">
                                  <Form.Check
                                    id="select-all"
                                    className="radio-primary pt-1"
                                    type="checkbox"
                                    name="statusFilters"
                                    label="Select All"
                                    value="2"
                                    onChange={(e) =>
                                      e.target.checked
                                        ? setStatusFilter(["1", "2", "3"])
                                        : setStatusFilter([])
                                    }
                                    checked={["1", "2", "3"].every((val) => statusFilter.includes(val))}
                                  />
                                </div>
                                <div className="px-3 py-2 border-bottom">
                                  <Form.Check
                                    className="radio-primary pt-1 mb-2"
                                    type="checkbox"
                                    name="statusFilters"
                                    label="Completed"
                                    id="radio-completed"
                                    value="2"
                                    onChange={(e) =>
                                      handleStatusFilterChange(e, "2")
                                    }
                                    checked={statusFilter.includes("2")}
                                  />
                                  <Form.Check
                                    className="radio-primary mb-2"
                                    type="checkbox"
                                    name="statusFilters"
                                    label="Pending"
                                    id="radio-pending"
                                    value="1"
                                    onChange={(e) =>
                                      handleStatusFilterChange(e, "1")
                                    }
                                    checked={statusFilter.includes("1")}
                                  />
                                  <Form.Check
                                    className="radio-primary mb-2"
                                    type="checkbox"
                                    name="statusFilters"
                                    label="Blocked"
                                    id="radio-blocked"
                                    value="3"
                                    onChange={(e) =>
                                      handleStatusFilterChange(e, "3")
                                    }
                                    checked={statusFilter.includes("3")}
                                  />
                                </div>
                                <div className="p-2 d-flex align-items-center justify-content-between">
                                  <button
                                    name="statusFilters"
                                    value={0}
                                    onClick={(e) => {
                                      setShowStatusDropdown(false);
                                      changeFilterCriteria(e);
                                      setStatusFilter([]);
                                    }}
                                    className="btn btn-xm btn-reset text-blue"
                                  >
                                    Reset
                                  </button>
                                  <button
                                    className="btn btn-xm btn-blue"
                                    onClick={handleStatusFilterApply}
                                  >
                                    Okay
                                  </button>
                                </div>
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                        </div>
                      </div>
                    </th>
                  );
                })}
                <th width="8%">Actions</th>
              </tr>
            </thead>
            <tbody>
              {inviteeListData?.length > 0 ? (
                inviteeListData?.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className={selectedItem?.id === row?.id && 'bg-gray-50'} onClick={() => rowHandler(row)}>
                      <div className="d-flex align-items-center gap-2">
                        {row?.invited_user?.profilePic ? (
                          <ImagePreviewLightbox
                            className="table-user-avtar"
                            src={row?.invited_user?.profilePic}
                          >
                            <Image
                              src={row?.invited_user?.profilePic}
                              className="object-fit-cover rounded-circle"
                              width="32"
                              height="32"
                              alt="User Avatar"
                            />
                          </ImagePreviewLightbox>
                        ) : (
                          <>
                            {row?.invited_user?.firstName && row?.invited_user?.lastName ?
                              <Image
                                width={32}
                                height={32}
                                alt="User Avatar"
                                className="object-fit-cover rounded-circle"
                                src={`https://ui-avatars.com/api/?name=${row.invited_user.firstName}+${row.invited_user.lastName}&background=007bff&color=fff&size=100`}
                              /> : <div className="user-avtar user-avtar-32 bg-blue-600"><span className="fs-15">N/A</span>
                              </div>
                            }

                          </>
                        )}

                        <span>
                          {row?.invited_user?.firstName ||
                            row?.invited_user?.lastName
                            ? `${row?.invited_user?.firstName || ""} ${row?.invited_user?.lastName || ""
                              }`.trim()
                            : "NA"}
                        </span>
                      </div>
                    </td>
                    <td className={selectedItem?.id === row?.id && 'bg-gray-50'} onClick={() => rowHandler(row)}>{row.email}</td>
                    <td className={selectedItem?.id === row?.id && 'bg-gray-50'} onClick={() => rowHandler(row)}>
                      {(!row?.status && (
                        <StatusBadgeClientInvite status={"Blocked"} />
                      )) || (
                          <StatusBadgeClientInvite
                            status={row.invited_user ? "Completed" : "Pending"}
                          />
                        )}
                    </td>
                    <td className={selectedItem?.id === row?.id && 'bg-gray-50'}>
                      <div className="column-action-btn d-flex align-items-center gap-3">
                        <Button
                          className="btn-reset"
                          onClick={() => rowHandler(row)}
                        >
                          <Image
                            src="/images/eye-primary.svg"
                            width={24}
                            height={24}
                            alt="Eye Icon"
                          />
                        </Button>
                        {auth.user.roleId !== 3 ? (
                          <Button
                            className="btn-reset"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedUser(row);
                              setShowModal(true);
                            }}
                          >
                            <Image
                              src={
                                row?.status
                                  ? "/images/prohibit-red.svg"
                                  : "/images/check-circle-green.svg"
                              }
                              width={24}
                              height={24}
                              alt={
                                row?.status
                                  ? "Prohibit Icon"
                                  : "Check Circle Icon"
                              }
                            />
                          </Button>
                        ) : (
                          <></>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="default-pointer">
                  <td
                    colSpan={columns.length + 1}
                    className="fw-semibold text-center"
                  >
                    {inviteeListData == null
                      ? "Loading..."
                      : "No Data Available"}
                  </td>
                </tr>
              )}
            </tbody>
          </DataTable>
          <TablePagination
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            totalResults={totalResults}
            resultsPerPage={10}
          />
        </CardWrapper>

        <ClientAccessDetailsPanel
          item={selectedItem}
          auth={auth}
          isOpen={!!selectedItem}
          updateInviteeListData={updateInviteeListData}
          updateInviteeStatusHandle={updateInviteeStatusHandle}
          onClose={() => setSelectedItem(null)}
        />
      </MainWrapper>

      <Modal
        className="invite-members-modal"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-5">Invite Contacts</Modal.Title>
        </Modal.Header>
        {/* <ProgressBar
          now={progress}
          variant="primary"
          animated
          style={{ height: "3x", borderRadius: 0 }}
        /> */}
        <Formik
          initialValues={{ emails: [""] }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={Yup.object({
            emails: Yup.array()
              .of(
                Yup.string()
                  .matches(
                    "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
                    "Enter a valid email address"
                  )
                  .required("Email address is required")
              )
              .min(1, "At least one email is required"),
            // .test("unique", "Emails must be unique", (emails) => {
            //   if (!emails) return true; // Avoid failing on empty (min will catch that)
            //   const seen = new Set();
            //   for (let email of emails) {
            //     if (seen.has(email?.toLowerCase())) return false;
            //     seen.add(email?.toLowerCase());
            //   }
            //   return true;
            // }),
          })}
          onSubmit={async (
            values,
            { setFieldValue, setValues, setErrors, setFieldError }
          ) => {
            const res = await inviteUsers({ emails: values.emails });
            const failedEmails = res?.errors || [];

            if (failedEmails.length > 0) {
              const filteredEmails = [];
              const errorObject = [];

              values.emails.forEach((email, index) => {
                const match = failedEmails.find(
                  (e) => e.email.toLowerCase() === email.toLowerCase()
                );
                if (match) {
                  filteredEmails.push(email);
                  errorObject.push(match.message);
                }
              });
              console.log("formikErrorsCustom", { emails: errorObject });
              console.log("formikErrorsValue", { emails: filteredEmails });

              //  setFieldError({ emails: errorObject });

              // setValues({ emails: filteredEmails })

              setErrors({ emails: errorObject });
              handleShowProgressBar();
              showAlert({
                title: "Contact Notification",
                message:
                  "Some Emails are failed to sent. please check input error message.",
                variant: "warning",
              });
              setTimeout(() => {
                console.log("filteredEmails", filteredEmails);
                setValues({ emails: filteredEmails });
              }, 5000);
              return;
            } else {
              await fetchInvitees();
              showAlert({
                title: "Contact Notification",
                message: res?.message ?? "something went wrong",
                variant: "success",
              });
              handleClose();
            }
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur }) => {
            console.log("formikErrors", errors);
            return (
              <FormikForm>
                <Modal.Body>
                  <FieldArray name="emails">
                    {({ push, remove }) => (
                      <>
                        {values.emails.map((email, index) => (
                          <div
                            className="d-flex align-items-center gap-2 position-relative mb-2"
                            key={index}
                          >
                            <div className="input-warpper w-100 email-icon">
                              <Field
                                name={`emails[${index}]`}
                                render={({ field, form }) => {
                                  const error = form.errors.emails?.[index];
                                  const touched = form.touched.emails?.[index]; // optional
                                  const isInvalid = !!error;

                                  return (
                                    <Form.Control
                                      {...field}
                                      type="text"
                                      placeholder="Enter e-mail"
                                      className={`form-control ${isInvalid ? "is-invalid" : ""
                                        }`}
                                    />
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`emails[${index}]`}
                                component="div"
                                className="text-danger text-position small ms-2 invalid-feedback"
                              />
                            </div>
                            {values.emails.length > 1 && (
                              <Button
                                className="btn-reset"
                                onClick={() => remove(index)}
                                type="button"
                              >
                                <Image
                                  src="/images/delete-red-rounded.svg"
                                  alt="Delete Icon"
                                />
                              </Button>
                            )}
                          </div>
                        ))}
                        <Button
                          className="btn-reset d-flex align-items-center gap-1 text-blue fw-semibold mt-3"
                          type="button"
                          onClick={() => push("")}
                        >
                          <Image
                            src="/images/plus-primary.svg"
                            width={20}
                            height={20}
                            alt="Plus Blue Icon"
                          />
                          Add New Email
                        </Button>
                      </>
                    )}
                  </FieldArray>
                </Modal.Body>
                <Modal.Footer className="justify-content-start">
                  <Button
                    className="btn-md d-flex align-items-center gap-1"
                    variant="primary"
                    type="submit"
                  >
                    <Image
                      src="/images/paper-plane-white.svg"
                      width={20}
                      height={20}
                      alt="Paper Plane Icon"
                    />
                    Send Invite
                  </Button>
                  <Button
                    className="btn-md"
                    variant="outline-secondary"
                    onClick={handleClose}
                    type="button"
                  >
                    Cancel
                  </Button>
                </Modal.Footer>
              </FormikForm>
            );
          }}
        </Formik>
      </Modal>

      <Modal
        className="info-modal"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image
              src={
                selectedUser?.status
                  ? "/images/prohibited-badge-red.svg"
                  : "/images/check-badge-green.svg"
              }
              alt="Prohibited Icon Badge"
            />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to{" "}
              {selectedUser?.status ? "block" : "unblock"} this user?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button
                onClick={() => updateInviteeStatusHandle(selectedUser)}
                variant="primary"
                className="btn w-100 mt-5"
              >
                Yes, {selectedUser?.status ? "Block User" : "Sure!"}
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModal(false)}
              >
                {selectedUser?.status ? "No, Not Yet!" : "Nope, Cancel"}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ClientAccess;
